interface PlacesVisibilityControlProperties {
  readonly hidden: boolean;
  readonly onChange: (hidden: boolean) => void;
}

export function PlacesVisibilityControl({ hidden, onChange }: PlacesVisibilityControlProperties) {
  return (
    <label className="tool-control tool-places-toggle">
      <input type="checkbox" role="switch" checked={hidden}
        onChange={event => onChange(event.target.checked)} />
      <strong>Hide places and facilities</strong>
    </label>
  );
}
